<template>
    <p class="text-left subheading pt-xs-5 mb-4">
        <slot></slot>
    </p>
</template>

<script>
export default {
    name: 'Subheading'
}
</script>
